import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';


const Drp_DocSaveType = forwardRef((props, ref) => {


    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const _Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id) {

            var temp = [];

            temp.push({
                Id: -1,
                Title: 'هیچکدام',
            },
                {
                    Id: 0,
                    Title: 'سند دستی',
                },
                {
                    Id: 1,
                    Title: "سیستمی - سند دریافت",
                },
                {
                    Id: 2,
                    Title: "سیستمی - سند تسویه کارت خوان",
                },
                {
                    Id: 3,
                    Title: "سیستمی - سند فاکتور فروش",
                },
                {
                    Id: 4,
                    Title: "سیستمی - سند پرداخت",
                },
                {
                    Id: 5,
                    Title: "سیستمی - سند واگذاری چک دریافتی نزد بانک",
                },
                {
                    Id: 6,
                    Title: "سیستمی - سند پاس شدن چک دریافتی نزد بانک",
                },
                {
                    Id: 7,
                    Title: "سیستمی - واخواست چک دریافتی (پاس نشدن چک)",
                },
                {
                    Id: 8,
                    Title: "سیستمی - عودت چک دریافتی (از صندق به مشتری) ",
                },
                {
                    Id: 9,
                    Title: "سیستمی - سند برگشت چک دریافتی ناشی از خرج کردن چک",
                },
                {
                    Id: 10,
                    Title: "سیستمی - سند نقد کردن چک دریافتی نزد صندوق",
                },
                {
                    Id: 11,
                    Title: "سیستمی - سند خرج کردن چک دریافتی",
                },
                {
                    Id: 12,
                    Title: "سیستمی - سند اختتامیه",
                },
                {
                    Id: 13,
                    Title: "سیستمی - سند افتتاحیه",
                },
                {
                    Id: 14,
                    Title: "سیستمی - سند فاکتور برگشت از فروش",
                },
                {
                    Id: 15,
                    Title: "پاس شدن - چک های پرداختی",
                },
                {
                    Id: 16,
                    Title: "سیستمی - برگشت چک های پرداختی",
                },
                {
                    Id: 17,
                    Title: "سیستمی - سند تهاتر",
                }


            )
            setId(id)
            props.onChange(id == null ? -1 : id, id == null ? "" : temp.find(x => x.Id == id).Title)
            setList(temp);





        },

    }))



    return (
        <rsuite.SelectPicker
            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => _Onchange(value)}

        />

    )
});

export default Drp_DocSaveType;